import React, { useState } from 'react';
import { TextField, Autocomplete, Select, MenuItem, InputLabel, FormControl, FormGroup, Typography, Box, Divider } from '@mui/material';
import '../../pages/createStudy/createStudy.css';


const ActiveStudyAccepted = ({ data }) => {
  const study = data && data[0];

  return (
    <Box sx={{ p: 3, color: '#169a8f', fontWeight: 'bold' }}>
      <Box>
        <Typography variant="h6">Study Criteria</Typography>
        <FormGroup row sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="status-label">Status</InputLabel>
            <Select
              labelId="status-label"
              id="status"
              value={study ? study.adminStudy.status : 'active'}
              label="Status"
            >
              <MenuItem value="active">Active</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ mr: 3 }}>
            <InputLabel id="phase-label">Phase</InputLabel>
            <Select
              labelId="phase-label"
              id="phase"
              value={study ? study.adminStudy.phase : 'Phase I'}
              label="Phase"
            >
              <MenuItem value={'Phase I'}>Phase I</MenuItem>
              <MenuItem value={'Phase II'}>Phase II</MenuItem>
              <MenuItem value={'Phase III'}>Phase III</MenuItem>
              <MenuItem value={'Phase IV'}>Phase IV</MenuItem>
            </Select>
          </FormControl>
          <TextField
            id="activation-date"
            label="Activation Date"
            type="date"
            value={study ? study.adminStudy.activationDate : new Date().toISOString().slice(0, 10)}
            InputLabelProps={{ shrink: true }}
            sx={{ mr: 3 }}
          />
          <TextField
            id="submission-date"
            label="Submission Date"
            type="date"
            defaultValue={new Date().toISOString().slice(0, 10)}
            InputLabelProps={{ shrink: true }}
            value={study ? study.adminStudy.submissionDate : new Date().toISOString().slice(0, 10)}
            sx={{ mr: 3 }}
          />
          <TextField id="PI" value={study && study.pi} label="PI" />
        </FormGroup>

        <TextField id="input-title" label="Title" value={study && study.adminStudy.title} fullWidth sx={{ mt: 2 }} />

        <TextField label="Therapeutic Areas" fullWidth value={study && study.adminStudy.therapeuticAreas} sx={{ mt: 2 }} />

        <TextField id="indication" value={study && study.adminStudy.indication} label="Indication" fullWidth sx={{ mt: 2 }} />
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">Study Sponsors</Typography>
        <FormGroup row sx={{ mt: 2 }}>
          <TextField id="name-sponsors" label="Name Sponsors" sx={{ mr: 3 }} />
          <TextField id="cro" label="CRO" value={study && study.adminStudy.CRO} />
        </FormGroup>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Divider />
        <Typography variant="h6" sx={{ mt: 2 }}>Criteria</Typography>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="inclusion-criteria"
            label="Inclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={study && study.adminStudy.inclusionCriteria}
          />
        </Box>
        <Box sx={{ mt: 2 }}>
          <TextField
            id="exclusion-criteria"
            label="Exclusion Criteria"
            multiline
            rows={6}
            fullWidth
            value={study && study.adminStudy.exclusionCriteria}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default ActiveStudyAccepted;
